export const iosInfo = {
  platform: 'ios',
  app_url: '',
  name: '',
  package_name: '',
  app_icon: '',
  desc: '',
  in_system: 0,
}

export const androidInfo = {
  platform: 'android',
  app_url: '',
  name: '',
  package_name: '',
  app_icon: '',
  desc: '',
  in_system: 0,
}

export const wxgameInfo = {
  name: '',
  package_name: '',
  app_icon: '',
  desc: '',
  in_system: 0,
}

export const appInfo = {
  ios: [iosInfo],
  android: [androidInfo],
  'android,ios': [iosInfo, androidInfo],
  wxgame: [wxgameInfo],
}

export const defaultInfo = {
  type: 'app',
  platforms: 'android,ios',
  app_info: appInfo['android,ios'],
}
